import { Popup } from '@approvalmax/ui';
import { FC, memo } from 'react';

import { messages } from './CheckDuplicatePopup.messages';
import { CheckDuplicatePopupProps } from './CheckDuplicatePopup.types';
import { DuplicateList } from './DuplicateList/DuplicateList';

export const CheckDuplicatePopup: FC<CheckDuplicatePopupProps> = memo((props) => {
    const { onCancel, onSuccess, onSuccessText, companyId, duplicates } = props;

    return (
        <Popup isOpen onRequestClose={onCancel}>
            <Popup.ConfirmationContent
                onConfirm={onSuccess}
                confirmButtonText={onSuccessText}
                onCancel={onCancel}
                cancelButtonText={messages.cancel}
                description={<DuplicateList companyId={companyId} possibleDuplicates={duplicates} />}
                title={messages.title}
            />
        </Popup>
    );
});

CheckDuplicatePopup.displayName = 'CheckDuplicatePopup';
